// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/views/Calculate/components/CalculateProfileResistance/styles.scss
// module id = 1264
// module chunks = 0